import { API_END_POINT } from '../utils/environment'
import axiosInstance from '../utils/axiosInstance'
import { validateApiParams } from '../utils/functions'
export interface PayloadLayoutId {
  type: string
  entityId: string
}

const LAYOUT_ENDPOINT = `${API_END_POINT.V3_ENTITY_MANAGER}layout`

const getLayoutByEntityIdTypeApi = async (payload: PayloadLayoutId) => {
  const url = LAYOUT_ENDPOINT
  const params = { type: payload?.type, entityId: payload?.entityId }
  try {
    validateApiParams(params, {
      endpoint: url,
      method: 'GET',
    })
    const response = await axiosInstance.get(url, { params })
    return response.data
  } catch (error) {
    console.error('Error fetching layout:', error)
    throw error
  }
}

export { getLayoutByEntityIdTypeApi }
